<template>
  <div id="app">
    <slot />
    <SubmissionConfirmationModal
      v-if="submitConfirmModalVisible"
      @click="setSubmitConfirmModalVisible(false)"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import SubmissionConfirmationModal from '@/components/SubmissionConfirmationModal.vue';

export default {
  name: 'CommonApp',
  components: {
    SubmissionConfirmationModal
  },
  computed: {
    ...mapState({
      submitConfirmModalVisible: state => state.app.submitConfirmModalVisible
    })
  },
  async created() {
    window.addEventListener('resize', this.getAndsetScreenSize);
    this.getAndsetScreenSize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getAndsetScreenSize);
  },
  methods: {
    ...mapMutations({
      setSubmitConfirmModalVisible: 'app/setSubmitConfirmModalVisible'
    }),
    ...mapActions({
      getAndsetScreenSize: 'app/getAndsetScreenSize'
    })
  }
};
</script>
